import { forwardRef } from 'react';
import { cx } from '@linaria/atomic';
import { LayoutGroup } from 'motion/react';
import type { CommonHTMLAttributes } from '@frontend/types';
import {
  tabBarBaseStyle,
  tabBarNonScrollableStyle,
  tabBarScrollableStyle,
  tabBarFullWidthStyle,
} from '../common-styles';

export type TabBarProps = CommonHTMLAttributes & {
  activeTab: string | undefined;
  children: Array<JSX.Element | boolean | null>;
  fullWidth?: boolean;
  isScrollable?: boolean;
  uniqueId?: string;
};

export const TabBar = forwardRef<HTMLDivElement, TabBarProps>(
  ({ activeTab, children, className, fullWidth, isScrollable, uniqueId, ...rest }, ref) => {
    return (
      <div
        ref={ref}
        className={cx(
          tabBarBaseStyle,
          isScrollable ? tabBarScrollableStyle : tabBarNonScrollableStyle,
          fullWidth && tabBarFullWidthStyle,
          className
        )}
        role='tablist'
        {...rest}
      >
        <LayoutGroup id={uniqueId}>{children}</LayoutGroup>
      </div>
    );
  }
);
